import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { KycManager } from "../../context-api/KycContext";
import { variableManager } from "../../context-api/VariableContex";

export default function PaymentsNavigation() {
  const {
    payModalShow,
    setPayModalShow,
    initPayModal,
    handleBillStatusChange,
  } = useContext(KycManager);

  const { user } = useContext(variableManager);
  const navigate = useNavigate();
  return (
    <div className="payments-navigation-container">
      <div
        className="bill active-bill pointer"
        onClick={() => {
          setPayModalShow({ ...initPayModal, receiveMethod: true });
          navigate("/user/dashboard/activities");
        }}
      >
        <div className="icon send-money ">
          <svg width="70" height="70" viewBox="0 0 70 70" fill="none">
            <g filter="url(#filter0_d_2264_42039)">
              <rect
                x="5"
                y="1"
                width="60"
                height="60"
                rx="7"
                stroke="white"
                strokeWidth="2"
              />
            </g>
            <path
              d="M26.9297 34.8792L38.8797 22.9292"
              stroke="white"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M34.1013 37.2791L35.3013 36.0791"
              stroke="white"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M36.793 34.5887L39.183 32.1987"
              stroke="white"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M26.6013 29.239L33.2413 22.599C35.3613 20.479 36.4213 20.469 38.5213 22.569L43.4313 27.479C45.5313 29.579 45.5213 30.639 43.4013 32.759L36.7613 39.399C34.6413 41.519 33.5813 41.529 31.4813 39.429L26.5713 34.519C24.4713 32.419 24.4713 31.369 26.6013 29.239Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25 40.9985H45"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <defs>
              <filter
                id="filter0_d_2264_42039"
                x="0"
                y="0"
                width="70"
                height="70"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_2264_42039"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_2264_42039"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div className="text">Deposit Money</div>
      </div>

      <div
        className="bill pointer"
        onClick={() => {
          if (user.Accounts[0]) {
            setPayModalShow({ ...payModalShow, chooseMethod: true });
          }
          navigate("/user/dashboard/activities");
        }}
      >
        <div className="icon ">
          <svg width="70" height="70" viewBox="0 0 70 70" fill="none">
            <g filter="url(#filter0_d_2264_42051)">
              <rect
                x="4.25"
                y="0.25"
                width="61.5"
                height="61.5"
                rx="7.75"
                stroke="#ADB7BE"
                strokeWidth="0.5"
              />
            </g>
            <path
              d="M25 31.6099H42"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M42 29.2798V36.4298C41.97 39.2798 41.19 39.9998 38.22 39.9998H28.78C25.76 39.9998 25 39.2498 25 36.2698V29.2798C25 26.5798 25.63 25.7098 28 25.5698C28.24 25.5598 28.5 25.5498 28.78 25.5498H38.22C41.24 25.5498 42 26.2998 42 29.2798Z"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M45 25.73V32.72C45 35.42 44.37 36.29 42 36.43V29.28C42 26.3 41.24 25.55 38.22 25.55H28.78C28.5 25.55 28.24 25.56 28 25.57C28.03 22.72 28.81 22 31.78 22H41.22C44.24 22 45 22.75 45 25.73Z"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M28.25 36.8101H29.97"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M32.11 36.8101H35.55"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <defs>
              <filter
                id="filter0_d_2264_42051"
                x="0"
                y="0"
                width="70"
                height="70"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_2264_42051"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_2264_42051"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div className="text">Send Money</div>
      </div>

      <div
        className="bill pointer"
        onClick={() => navigate("/user/dashboard/pos")}
      >
        <div className="icon">
          <svg width="70" height="70" viewBox="0 0 70 70" fill="none">
            <g filter="url(#filter0_d_2307_41793)">
              <rect
                x="4.25"
                y="0.25"
                width="61.5"
                height="61.5"
                rx="7.75"
                stroke="#ADB7BE"
                strokeWidth="0.5"
              />
            </g>
            <path
              d="M28.94 43C28.5581 43 28.1918 42.8483 27.9218 42.5782C27.6517 42.3082 27.5 41.9419 27.5 41.56V24.656C27.5 23.861 28.145 23.216 28.94 23.216H30.646C30.7 23.216 30.752 23.229 30.797 23.252L30.795 23.251V19.168C30.795 19.075 30.87 19 30.963 19H36.983C37.076 19 37.151 19.075 37.151 19.168V23.227C37.1772 23.2205 37.204 23.2171 37.231 23.217H38.746C39.541 23.217 40.186 23.862 40.186 24.657V28.688C40.2311 28.666 40.2808 28.6547 40.331 28.655H41.088C41.274 28.655 41.425 28.806 41.425 28.992V37.764C41.425 37.8534 41.3895 37.9391 41.3263 38.0023C41.2631 38.0655 41.1774 38.101 41.088 38.101H40.331C40.28 38.1012 40.2297 38.0895 40.184 38.067L40.186 38.068V41.56C40.186 41.9419 40.0343 42.3082 39.7642 42.5782C39.4942 42.8483 39.1279 43 38.746 43H28.94ZM36.264 39.769V40.903C36.2643 40.9477 36.2822 40.9906 36.3138 41.0222C36.3454 41.0538 36.3883 41.0717 36.433 41.072H37.767C37.8117 41.0717 37.8546 41.0538 37.8862 41.0222C37.9178 40.9906 37.9357 40.9477 37.936 40.903V39.769C37.9357 39.7244 37.9178 39.6816 37.8861 39.6501C37.8545 39.6187 37.8116 39.601 37.767 39.601H36.431C36.3864 39.6013 36.3437 39.619 36.3121 39.6504C36.2805 39.6819 36.2625 39.7244 36.262 39.769H36.264ZM33.108 39.769V40.903C33.1083 40.9477 33.1262 40.9906 33.1578 41.0222C33.1894 41.0538 33.2323 41.0717 33.277 41.072H34.61C34.6547 41.0717 34.6976 41.0538 34.7292 41.0222C34.7608 40.9906 34.7787 40.9477 34.779 40.903V39.769C34.7787 39.7244 34.7608 39.6816 34.7291 39.6501C34.6975 39.6187 34.6546 39.601 34.61 39.601H33.276C33.2314 39.6013 33.1887 39.619 33.1571 39.6504C33.1255 39.6819 33.1085 39.7244 33.108 39.769ZM29.952 39.769V40.904C29.952 40.997 30.027 41.072 30.12 41.072H31.454C31.4987 41.0717 31.5416 41.0538 31.5732 41.0222C31.6048 40.9906 31.6227 40.9477 31.623 40.903V39.769C31.6227 39.7244 31.6048 39.6816 31.5731 39.6501C31.5415 39.6187 31.4986 39.601 31.454 39.601H30.12C30.0754 39.601 30.0327 39.6187 30.0012 39.6502C29.9697 39.6817 29.952 39.7244 29.952 39.769ZM36.263 37.198V38.332C36.2633 38.3767 36.2812 38.4196 36.3128 38.4512C36.3444 38.4828 36.3873 38.5007 36.432 38.501H37.766C37.8107 38.5007 37.8536 38.4828 37.8852 38.4512C37.9168 38.4196 37.9347 38.3767 37.935 38.332V37.197C37.935 37.1524 37.9173 37.1097 37.8858 37.0782C37.8543 37.0467 37.8116 37.029 37.767 37.029H36.43C36.3854 37.029 36.3427 37.0467 36.3112 37.0782C36.2797 37.1097 36.262 37.1524 36.262 37.197L36.263 37.198ZM33.107 37.198V38.332C33.1073 38.3767 33.1252 38.4196 33.1568 38.4512C33.1884 38.4828 33.2313 38.5007 33.276 38.501H34.61C34.6547 38.5007 34.6976 38.4828 34.7292 38.4512C34.7608 38.4196 34.7787 38.3767 34.779 38.332V37.197C34.779 37.1524 34.7613 37.1097 34.7298 37.0782C34.6983 37.0467 34.6556 37.029 34.611 37.029H33.275C33.2304 37.029 33.1877 37.0467 33.1562 37.0782C33.1247 37.1097 33.107 37.1534 33.107 37.198ZM29.951 37.198V38.333C29.951 38.426 30.026 38.501 30.119 38.501H31.453C31.4977 38.5007 31.5406 38.4828 31.5722 38.4512C31.6038 38.4196 31.6217 38.3767 31.622 38.332V37.197C31.622 37.1524 31.6043 37.1097 31.5728 37.0782C31.5413 37.0467 31.4986 37.029 31.454 37.029H30.119C30.0744 37.029 30.0317 37.0467 30.0002 37.0782C29.9687 37.1097 29.951 37.1534 29.951 37.198ZM36.262 34.626V35.761C36.262 35.854 36.337 35.929 36.43 35.929H37.766C37.8106 35.929 37.8533 35.9113 37.8848 35.8798C37.9163 35.8483 37.934 35.8056 37.934 35.761V34.626C37.9337 34.5814 37.9158 34.5386 37.8841 34.5071C37.8525 34.4757 37.8096 34.458 37.765 34.458H36.431C36.3864 34.4583 36.3437 34.476 36.3121 34.5074C36.2805 34.5389 36.2625 34.5814 36.262 34.626ZM33.106 34.626V35.761C33.106 35.854 33.181 35.929 33.274 35.929H34.61C34.6546 35.929 34.6973 35.9113 34.7288 35.8798C34.7603 35.8483 34.778 35.8056 34.778 35.761V34.626C34.7777 34.5814 34.7598 34.5386 34.7281 34.5071C34.6965 34.4757 34.6536 34.458 34.609 34.458H33.275C33.2304 34.4583 33.1877 34.476 33.1561 34.5074C33.1245 34.5389 33.1065 34.5814 33.106 34.626ZM29.95 34.626V35.761C29.95 35.854 30.025 35.929 30.118 35.929H31.454C31.4986 35.929 31.5413 35.9113 31.5728 35.8798C31.6043 35.8483 31.622 35.8056 31.622 35.761V34.626C31.6217 34.5814 31.6038 34.5386 31.5721 34.5071C31.5405 34.4757 31.4976 34.458 31.453 34.458H30.119C30.0744 34.458 30.0317 34.4757 30.0002 34.5072C29.9687 34.5387 29.95 34.5814 29.95 34.626ZM29.74 27.913V32.825C29.74 32.918 29.815 32.993 29.908 32.993H37.67C37.7146 32.993 37.7573 32.9753 37.7888 32.9438C37.8203 32.9123 37.838 32.8696 37.838 32.825V27.913C37.8377 27.8683 37.8198 27.8254 37.7882 27.7938C37.7566 27.7622 37.7137 27.7443 37.669 27.744H29.909C29.8643 27.7443 29.8214 27.7622 29.7898 27.7938C29.7582 27.8254 29.7403 27.8683 29.74 27.913ZM29.236 25.231V26.421C29.236 26.7 29.462 26.926 29.741 26.926H38.14C38.2739 26.926 38.4024 26.8728 38.4971 26.7781C38.5918 26.6834 38.645 26.5549 38.645 26.421V25.231C38.645 25.0971 38.5918 24.9686 38.4971 24.8739C38.4024 24.7792 38.2739 24.726 38.14 24.726H37.15V25.736H37.638V25.914H30.246V25.736H30.567C30.6481 25.736 30.728 25.7164 30.8 25.679L30.797 25.68V24.782C30.7256 24.745 30.6464 24.7258 30.566 24.726H29.739C29.6052 24.7263 29.477 24.7796 29.3826 24.8743C29.2881 24.9689 29.236 25.0972 29.236 25.231Z"
              fill="#292D32"
            />
            <defs>
              <filter
                id="filter0_d_2307_41793"
                x="0"
                y="0"
                width="70"
                height="70"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_2307_41793"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_2307_41793"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div className="text">POS Terminals</div>
      </div>

      {/* NOT NECESSARY FOR SPRINT ONE */}

      <div
        className="bill pointer"
        onClick={() => {
          handleBillStatusChange("airtime", "details");
        }}
      >
        <div className="icon">
          <svg width="70" height="70" viewBox="0 0 70 70" fill="none">
            <g filter="url(#filter0_d_2264_42075)">
              <rect
                x="4.25"
                y="0.25"
                width="61.5"
                height="61.5"
                rx="7.75"
                stroke="#ADB7BE"
                strokeWidth="0.5"
              />
            </g>
            <path
              d="M45 25V27.42C45 29 44 30 42.42 30H39V23.01C39 21.9 39.91 21 41.02 21C42.11 21.01 43.11 21.45 43.83 22.17C44.55 22.9 45 23.9 45 25Z"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25 26V40C25 40.83 25.94 41.3 26.6 40.8L28.31 39.52C28.71 39.22 29.27 39.26 29.63 39.62L31.29 41.29C31.68 41.68 32.32 41.68 32.71 41.29L34.39 39.61C34.74 39.26 35.3 39.22 35.69 39.52L37.4 40.8C38.06 41.29 39 40.82 39 40V23C39 21.9 39.9 21 41 21H30H29C26 21 25 22.79 25 25V26Z"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <defs>
              <filter
                id="filter0_d_2264_42075"
                x="0"
                y="0"
                width="70"
                height="70"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_2264_42075"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_2264_42075"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div className="text">Airtime</div>
      </div>

      <div
        className="bill pointer"
        onClick={() => {
          handleBillStatusChange("cableTv", "details");
        }}
      >
        <div className="icon">
          <svg
            width="70"
            height="70"
            viewBox="0 0 70 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_467_64727)">
              <rect
                x="4.25"
                y="0.25"
                width="61.5"
                height="61.5"
                rx="7.75"
                stroke="#ADB7BE"
                strokeWidth="0.5"
              />
            </g>
            <path
              d="M41 38.5H29C27.338 38.5 26 37.162 26 35.5V28C26 26.338 27.338 25 29 25H41C42.662 25 44 26.338 44 28V35.5C44 37.162 42.662 38.5 41 38.5Z"
              stroke="#737B8B"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M32 41.5H38"
              stroke="#737B8B"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M35 25L39.5 20.5"
              stroke="#737B8B"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M35 25L30.5 20.5"
              stroke="#737B8B"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <defs>
              <filter
                id="filter0_d_467_64727"
                x="0"
                y="0"
                width="70"
                height="70"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_467_64727"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_467_64727"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div className="text">Cable TV</div>
      </div>

      {/* <div
        className="bill pointer"
        onClick={() => {
          handleBillStatusChange("electricity", "details");
        }}
      >
        <div className="icon">
          <svg
            width="70"
            height="70"
            viewBox="0 0 70 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_2264_42091)">
              <rect
                x="4.25"
                y="0.25"
                width="61.5"
                height="61.5"
                rx="7.75"
                stroke="#ADB7BE"
                strokeWidth="0.5"
              />
            </g>
            <path
              d="M33.11 30.1504H30.4601C29.8301 30.1504 29.3201 30.6603 29.3201 31.2903V36.4103H33.11V30.1504V30.1504Z"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M35.7613 25.6001H34.2413C33.6113 25.6001 33.1013 26.1101 33.1013 26.7401V36.4001H36.8913V26.7401C36.8913 26.1101 36.3913 25.6001 35.7613 25.6001Z"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M39.5482 31.8501H36.8982V36.4001H40.6882V32.9901C40.6782 32.3601 40.1682 31.8501 39.5482 31.8501Z"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M32 41H38C43 41 45 39 45 34V28C45 23 43 21 38 21H32C27 21 25 23 25 28V34C25 39 27 41 32 41Z"
              stroke="#292D32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <defs>
              <filter
                id="filter0_d_2264_42091"
                x="0"
                y="0"
                width="70"
                height="70"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_2264_42091"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_2264_42091"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div className="text">Electricity</div>
      </div>

      <div
        className="bill pointer"
        onClick={() => {
          navigate("/user/dashboard/bills")
        }}
      >
        <div className="icon">
        <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_467_80681)">
          <rect
            x="4.25"
            y="0.25"
            width="61.5"
            height="61.5"
            rx="7.75"
            stroke="#ADB7BE"
            strokeWidth="0.5"
          />
        </g>
        <mask
          id="mask0_467_80681"
          style={{"maskType":"luminance"}}
          maskUnits="userSpaceOnUse"
          x="23"
          y="20"
          width="23"
          height="22"
        >
          <path
            d="M31.5 21H25.5C25.2348 21 24.9804 21.1054 24.7929 21.2929C24.6054 21.4804 24.5 21.7348 24.5 22V28C24.5 28.2652 24.6054 28.5196 24.7929 28.7071C24.9804 28.8946 25.2348 29 25.5 29H31.5C31.7652 29 32.0196 28.8946 32.2071 28.7071C32.3946 28.5196 32.5 28.2652 32.5 28V22C32.5 21.7348 32.3946 21.4804 32.2071 21.2929C32.0196 21.1054 31.7652 21 31.5 21ZM31.5 33H25.5C25.2348 33 24.9804 33.1054 24.7929 33.2929C24.6054 33.4804 24.5 33.7348 24.5 34V40C24.5 40.2652 24.6054 40.5196 24.7929 40.7071C24.9804 40.8946 25.2348 41 25.5 41H31.5C31.7652 41 32.0196 40.8946 32.2071 40.7071C32.3946 40.5196 32.5 40.2652 32.5 40V34C32.5 33.7348 32.3946 33.4804 32.2071 33.2929C32.0196 33.1054 31.7652 33 31.5 33ZM43.5 21H37.5C37.2348 21 36.9804 21.1054 36.7929 21.2929C36.6054 21.4804 36.5 21.7348 36.5 22V28C36.5 28.2652 36.6054 28.5196 36.7929 28.7071C36.9804 28.8946 37.2348 29 37.5 29H43.5C43.7652 29 44.0196 28.8946 44.2071 28.7071C44.3946 28.5196 44.5 28.2652 44.5 28V22C44.5 21.7348 44.3946 21.4804 44.2071 21.2929C44.0196 21.1054 43.7652 21 43.5 21Z"
            fill="white"
            stroke="white"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M36.5 33H44.5M40.5 37H44.5M36.5 41H44.5"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </mask>
        <g mask="url(#mask0_467_80681)">
          <path d="M22.5 19H46.5V43H22.5V19Z" fill="#737B8B" />
        </g>
        <defs>
          <filter
            id="filter0_d_467_80681"
            x="0"
            y="0"
            width="70"
            height="70"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_467_80681"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_467_80681"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
        </div>
        <div className="text">More</div>
      </div> */}



      {/*
            <div className="bill ">
                <div className="icon">
                    <svg width="70" height="70" viewBox="0 0 70 70" fill="none"  >
                        <g filter="url(#filter0_d_2264_42062)">
                            <rect x="4.25" y="0.25" width="61.5" height="61.5" rx="7.75" stroke="#ADB7BE" strokeWidth="0.5" />
                        </g>
                        <path d="M37.2617 34.998H32.2617" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M35.66 21.5181L35.63 21.5881L32.73 28.3181H29.88C29.2 28.3181 28.55 28.4581 27.96 28.7081L29.71 24.5281L29.75 24.4281L29.82 24.2681C29.84 24.2081 29.86 24.1481 29.89 24.0981C31.2 21.0681 32.68 20.3781 35.66 21.5181Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M41.05 28.5181C40.6 28.3781 40.12 28.3181 39.64 28.3181H32.73L35.63 21.5881L35.66 21.5181C35.81 21.5681 35.95 21.6381 36.1 21.6981L38.31 22.6281C39.54 23.1381 40.4 23.6681 40.92 24.3081C41.02 24.4281 41.1 24.5381 41.17 24.6681C41.26 24.8081 41.33 24.9481 41.37 25.0981C41.41 25.1881 41.44 25.2781 41.46 25.3581C41.73 26.1981 41.57 27.2281 41.05 28.5181Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M44.5217 33.1984V35.1484C44.5217 35.3484 44.5117 35.5484 44.5017 35.7484C44.3117 39.2384 42.3617 40.9984 38.6617 40.9984H30.8617C30.6217 40.9984 30.3817 40.9784 30.1517 40.9484C26.9717 40.7384 25.2717 39.0384 25.0617 35.8584C25.0317 35.6284 25.0117 35.3884 25.0117 35.1484V33.1984C25.0117 31.1884 26.2317 29.4584 27.9717 28.7084C28.5717 28.4584 29.2117 28.3184 29.8917 28.3184H39.6517C40.1417 28.3184 40.6217 28.3884 41.0617 28.5184C43.0517 29.1284 44.5217 30.9884 44.5217 33.1984Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M29.71 24.5283L27.96 28.7083C26.22 29.4583 25 31.1883 25 33.1983V30.2683C25 27.4283 27.02 25.0583 29.71 24.5283Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M44.5186 30.2677V33.1977C44.5186 30.9977 43.0586 29.1277 41.0586 28.5277C41.5786 27.2277 41.7286 26.2077 41.4786 25.3577C41.4586 25.2677 41.4286 25.1777 41.3886 25.0977C43.2486 26.0577 44.5186 28.0277 44.5186 30.2677Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <defs>
                            <filter id="filter0_d_2264_42062" x="0" y="0" width="70" height="70" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2264_42062" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2264_42062" result="shape" />
                            </filter>
                        </defs>
                    </svg>
                </div>
                <div className="text">
                    Saving Account
                </div>
            </div>







            <div className="bill">
                <div className="icon">
                    <svg width="70" height="70" viewBox="0 0 70 70" fill="none"  >
                        <g filter="url(#filter0_d_2264_42101)">
                            <rect x="4.25" y="0.25" width="61.5" height="61.5" rx="7.75" stroke="#ADB7BE" strokeWidth="0.5" />
                        </g>
                        <path d="M33.11 30.1504H30.4601C29.8301 30.1504 29.3201 30.6603 29.3201 31.2903V36.4103H33.11V30.1504V30.1504Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M35.7613 25.6001H34.2413C33.6113 25.6001 33.1013 26.1101 33.1013 26.7401V36.4001H36.8913V26.7401C36.8913 26.1101 36.3913 25.6001 35.7613 25.6001Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M39.5482 31.8501H36.8982V36.4001H40.6882V32.9901C40.6782 32.3601 40.1682 31.8501 39.5482 31.8501Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M32 41H38C43 41 45 39 45 34V28C45 23 43 21 38 21H32C27 21 25 23 25 28V34C25 39 27 41 32 41Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <defs>
                            <filter id="filter0_d_2264_42101" x="0" y="0" width="70" height="70" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2264_42101" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2264_42101" result="shape" />
                            </filter>
                        </defs>
                    </svg>

                </div>
                <div className="text">
                    Data
                </div>
            </div>



            <div className="bill">
                <div className="icon">
                    <svg width="70" height="70" viewBox="0 0 70 70" fill="none"  >
                        <g filter="url(#filter0_d_2264_42101)">
                            <rect x="4.25" y="0.25" width="61.5" height="61.5" rx="7.75" stroke="#ADB7BE" strokeWidth="0.5" />
                        </g>
                        <path d="M33.11 30.1504H30.4601C29.8301 30.1504 29.3201 30.6603 29.3201 31.2903V36.4103H33.11V30.1504V30.1504Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M35.7613 25.6001H34.2413C33.6113 25.6001 33.1013 26.1101 33.1013 26.7401V36.4001H36.8913V26.7401C36.8913 26.1101 36.3913 25.6001 35.7613 25.6001Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M39.5482 31.8501H36.8982V36.4001H40.6882V32.9901C40.6782 32.3601 40.1682 31.8501 39.5482 31.8501Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M32 41H38C43 41 45 39 45 34V28C45 23 43 21 38 21H32C27 21 25 23 25 28V34C25 39 27 41 32 41Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <defs>
                            <filter id="filter0_d_2264_42101" x="0" y="0" width="70" height="70" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2264_42101" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2264_42101" result="shape" />
                            </filter>
                        </defs>
                    </svg>

                </div>
                <div className="text">
                    Electricity
                </div>
            </div>



            <div className="bill">
                <div className="icon">
                    <svg width="70" height="70" viewBox="0 0 70 70" fill="none"  >
                        <g filter="url(#filter0_d_2264_42105)">
                            <rect x="4.25" y="0.25" width="61.5" height="61.5" rx="7.75" stroke="#ADB7BE" strokeWidth="0.5" />
                        </g>
                        <path d="M42.75 22.75H26.25C25.8522 22.75 25.4707 22.908 25.1894 23.1893C24.908 23.4706 24.75 23.8522 24.75 24.25V39.25C24.7492 39.378 24.7817 39.504 24.8441 39.6157C24.9065 39.7274 24.9969 39.8211 25.1063 39.8875C25.2148 39.9557 25.339 39.995 25.467 40.0016C25.595 40.0081 25.7226 39.9818 25.8375 39.925L28.5 38.5844L31.1625 39.925C31.2678 39.9757 31.3832 40.002 31.5 40.002C31.6169 40.002 31.7322 39.9757 31.8375 39.925L34.5 38.5844L37.1625 39.925C37.2682 39.9744 37.3834 40 37.5 40C37.6166 40 37.7319 39.9744 37.8375 39.925L40.5 38.5844L43.1625 39.925C43.2774 39.9818 43.405 40.0081 43.533 40.0016C43.661 39.995 43.7852 39.9557 43.8938 39.8875C44.0032 39.8211 44.0935 39.7274 44.1559 39.6157C44.2184 39.504 44.2508 39.378 44.25 39.25V24.25C44.25 23.8522 44.092 23.4706 43.8107 23.1893C43.5294 22.908 43.1478 22.75 42.75 22.75ZM42.75 38.0406L40.8375 37.075C40.7322 37.0243 40.6169 36.998 40.5 36.998C40.3832 36.998 40.2678 37.0243 40.1625 37.075L37.5 38.4156L34.8375 37.075C34.7319 37.0256 34.6166 37 34.5 37C34.3834 37 34.2682 37.0256 34.1625 37.075L31.5 38.4156L28.8375 37.075C28.7322 37.0243 28.6169 36.998 28.5 36.998C28.3832 36.998 28.2678 37.0243 28.1625 37.075L26.25 38.0406V24.25H42.75V38.0406ZM28.9125 34.675C29.0921 34.7608 29.298 34.7735 29.4869 34.7106C29.6757 34.6476 29.8328 34.5139 29.925 34.3375L30.4594 33.25H34.0406L34.575 34.3375C34.6388 34.4616 34.7355 34.5658 34.8546 34.6386C34.9736 34.7114 35.1105 34.7499 35.25 34.75C35.3664 34.7475 35.4811 34.722 35.5875 34.675C35.7639 34.5828 35.8977 34.4257 35.9606 34.2369C36.0235 34.048 36.0108 33.8421 35.925 33.6625L32.925 27.6625C32.8611 27.5385 32.7643 27.4346 32.6453 27.362C32.5262 27.2894 32.3895 27.251 32.25 27.251C32.1106 27.251 31.9738 27.2894 31.8547 27.362C31.7357 27.4346 31.6389 27.5385 31.575 27.6625L28.575 33.6625C28.4892 33.8421 28.4765 34.048 28.5394 34.2369C28.6024 34.4257 28.7361 34.5828 28.9125 34.675ZM32.25 29.6781L33.2906 31.75H31.2094L32.25 29.6781ZM36 31C36 30.8011 36.079 30.6103 36.2197 30.4697C36.3603 30.329 36.5511 30.25 36.75 30.25H37.875V29.125C37.875 28.9261 37.954 28.7353 38.0947 28.5947C38.2353 28.454 38.4261 28.375 38.625 28.375C38.8239 28.375 39.0147 28.454 39.1553 28.5947C39.296 28.7353 39.375 28.9261 39.375 29.125V30.25H40.5C40.6989 30.25 40.8897 30.329 41.0303 30.4697C41.171 30.6103 41.25 30.8011 41.25 31C41.25 31.1989 41.171 31.3897 41.0303 31.5303C40.8897 31.671 40.6989 31.75 40.5 31.75H39.375V32.875C39.375 33.0739 39.296 33.2647 39.1553 33.4053C39.0147 33.546 38.8239 33.625 38.625 33.625C38.4261 33.625 38.2353 33.546 38.0947 33.4053C37.954 33.2647 37.875 33.0739 37.875 32.875V31.75H36.75C36.5511 31.75 36.3603 31.671 36.2197 31.5303C36.079 31.3897 36 31.1989 36 31Z" fill="#292D32" />
                        <defs>
                            <filter id="filter0_d_2264_42105" x="0" y="0" width="70" height="70" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2264_42105" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2264_42105" result="shape" />
                            </filter>
                        </defs>
                    </svg>

                </div>
                <div className="text">
                    WAEC
                </div>
            </div>



            <div className="bill">
                <div className="icon">
                    <svg width="70" height="70" viewBox="0 0 70 70" fill="none">
                        <g filter="url(#filter0_d_2264_42109)">
                            <rect x="4.25" y="0.25" width="61.5" height="61.5" rx="7.75" stroke="#ADB7BE" strokeWidth="0.5" />
                        </g>
                        <path d="M34.5 23V24M40.5 35H42.5M36.5 35H34.5V39M34.5 28V31M34.5 31H34.51M34.5 31H38.51M38.5 39H42.5M26.5 31H30.5M42.5 31H42.51M27.5 27H29.5C29.7652 27 30.0196 26.8946 30.2071 26.7071C30.3946 26.5196 30.5 26.2652 30.5 26V24C30.5 23.7348 30.3946 23.4804 30.2071 23.2929C30.0196 23.1054 29.7652 23 29.5 23H27.5C27.2348 23 26.9804 23.1054 26.7929 23.2929C26.6054 23.4804 26.5 23.7348 26.5 24V26C26.5 26.2652 26.6054 26.5196 26.7929 26.7071C26.9804 26.8946 27.2348 27 27.5 27ZM39.5 27H41.5C41.7652 27 42.0196 26.8946 42.2071 26.7071C42.3946 26.5196 42.5 26.2652 42.5 26V24C42.5 23.7348 42.3946 23.4804 42.2071 23.2929C42.0196 23.1054 41.7652 23 41.5 23H39.5C39.2348 23 38.9804 23.1054 38.7929 23.2929C38.6054 23.4804 38.5 23.7348 38.5 24V26C38.5 26.2652 38.6054 26.5196 38.7929 26.7071C38.9804 26.8946 39.2348 27 39.5 27ZM27.5 39H29.5C29.7652 39 30.0196 38.8946 30.2071 38.7071C30.3946 38.5196 30.5 38.2652 30.5 38V36C30.5 35.7348 30.3946 35.4804 30.2071 35.2929C30.0196 35.1054 29.7652 35 29.5 35H27.5C27.2348 35 26.9804 35.1054 26.7929 35.2929C26.6054 35.4804 26.5 35.7348 26.5 36V38C26.5 38.2652 26.6054 38.5196 26.7929 38.7071C26.9804 38.8946 27.2348 39 27.5 39Z" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <defs>
                            <filter id="filter0_d_2264_42109" x="0" y="0" width="70" height="70" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2264_42109" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2264_42109" result="shape" />
                            </filter>
                        </defs>
                    </svg>

                </div>
                <div className="text">
                    QRCode
                </div>
            </div>
 */}
    </div>
  );
}
